import { normalizeSearchText } from "../../services/search/searchText";

export const DEFAULT_MAX_SHOW_PICKER_SUGGESTIONS = 8;

const alwaysEligible = () => true;
const noPreference = () => 0;

export function buildShowPickerSuggestions({
  shows = [],
  query = "",
  excludeSlug = "",
  maxSuggestions = DEFAULT_MAX_SHOW_PICKER_SUGGESTIONS,
  isEligible = alwaysEligible,
  getPreferenceScore = noPreference,
} = {}) {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery || maxSuggestions <= 0) {
    return [];
  }

  const matches = [];
  for (const show of shows) {
    if (!show?.slug || show.slug === excludeSlug || !isEligible(show)) continue;

    const normalizedTitle = normalizeSearchText(show.title || "");
    if (!normalizedTitle) continue;

    const titleTokens = show?._search?.titleTokens || normalizedTitle.split(" ");
    let score = 0;
    if (normalizedTitle === normalizedQuery) {
      score = 100;
    } else if (normalizedTitle.startsWith(normalizedQuery)) {
      score = 80;
    } else if (normalizedTitle.includes(normalizedQuery)) {
      score = 60;
    } else if (titleTokens.some((token) => token.startsWith(normalizedQuery))) {
      score = 40;
    } else {
      continue;
    }

    const preferenceScore = Number(getPreferenceScore(show));
    matches.push({
      show,
      titleScore: score,
      preferenceScore: Number.isFinite(preferenceScore) ? preferenceScore : 0,
    });
  }

  matches.sort((left, right) => {
    if (right.titleScore !== left.titleScore) return right.titleScore - left.titleScore;
    if (right.preferenceScore !== left.preferenceScore) {
      return right.preferenceScore - left.preferenceScore;
    }
    return (left.show.title || "").localeCompare(right.show.title || "");
  });

  return matches.slice(0, maxSuggestions).map((entry) => entry.show);
}
